import * as i0 from '@angular/core';
import * as i1 from './base-calendar.module';
import * as i2 from '../calendar-kit/components/calendar-header/calendar-header.component';
import * as i3 from '../calendar-kit/components/calendar-navigation/calendar-navigation.component';
import * as i4 from '../calendar-kit/components/calendar-navigation/calendar-pageable-navigation.component';
import * as i5 from '../calendar-kit/components/calendar-days-names/calendar-days-names.component';
import * as i6 from '../calendar-kit/components/calendar-year-picker/calendar-year-picker.component';
import * as i7 from '../calendar-kit/components/calendar-month-picker/calendar-month-picker.component';
import * as i8 from '../calendar-kit/components/calendar-day-picker/calendar-day-picker.component';
import * as i9 from '../calendar-kit/components/calendar-day-picker/calendar-day-cell.component';
import * as i10 from '../calendar-kit/components/calendar-month-picker/calendar-month-cell.component';
import * as i11 from '../calendar-kit/components/calendar-year-picker/calendar-year-cell.component';
import * as i12 from '../calendar-kit/components/calendar-picker/calendar-picker-row.component';
import * as i13 from '../calendar-kit/components/calendar-picker/calendar-picker.component';
import * as i14 from '../calendar-kit/components/calendar-week-number/el-calendar-week-number.component';
import * as i15 from '@angular/common';
import * as i16 from '@angular/forms';
import * as i17 from '@angular/router';
import * as i18 from '../card/card.component';
import * as i19 from '../card/reveal-card/reveal-card.component';
import * as i20 from '../card/flip-card/flip-card.component';
import * as i21 from '../card/shared/shared.component';
import * as i22 from './base-calendar.component';
import * as i23 from '../calendar-kit/calendar-kit.module';
import * as i24 from '../shared/shared.module';
import * as i25 from '../card/card.module';
export const ElBaseCalendarModuleNgFactory:i0.NgModuleFactory<i1.ElBaseCalendarModule> = (null as any);
var _decl0_0:i2.ElCalendarHeaderComponent<any> = (<any>(null as any));
var _decl0_1:i3.ElCalendarNavigationComponent<any> = (<any>(null as any));
var _decl0_2:i4.ElCalendarPageableNavigationComponent<any> = (<any>(null as any));
var _decl0_3:i5.ElCalendarDaysNamesComponent<any> = (<any>(null as any));
var _decl0_4:i6.ElCalendarYearPickerComponent<any> = (<any>(null as any));
var _decl0_5:i7.ElCalendarMonthPickerComponent<any,any> = (<any>(null as any));
var _decl0_6:i8.ElCalendarDayPickerComponent<any,any> = (<any>(null as any));
var _decl0_7:i9.ElCalendarDayCellComponent<any> = (<any>(null as any));
var _decl0_8:i10.ElCalendarMonthCellComponent<any> = (<any>(null as any));
var _decl0_9:i11.ElCalendarYearCellComponent<any> = (<any>(null as any));
var _decl0_10:i12.ElCalendarPickerRowComponent<any,any> = (<any>(null as any));
var _decl0_11:i13.ElCalendarPickerComponent<any,any> = (<any>(null as any));
var _decl0_12:i14.ElCalendarWeekNumberComponent<any> = (<any>(null as any));
var _decl0_13:i15.NgClass = (<any>(null as any));
var _decl0_14:i15.NgComponentOutlet = (<any>(null as any));
var _decl0_15:i15.NgForOf<any> = (<any>(null as any));
var _decl0_16:i15.NgIf = (<any>(null as any));
var _decl0_17:i15.NgTemplateOutlet = (<any>(null as any));
var _decl0_18:i15.NgStyle = (<any>(null as any));
var _decl0_19:i15.NgSwitch = (<any>(null as any));
var _decl0_20:i15.NgSwitchCase = (<any>(null as any));
var _decl0_21:i15.NgSwitchDefault = (<any>(null as any));
var _decl0_22:i15.NgPlural = (<any>(null as any));
var _decl0_23:i15.NgPluralCase = (<any>(null as any));
var _decl0_24:i16.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_25:i16.NgSelectOption = (<any>(null as any));
var _decl0_26:i16.ɵangular_packages_forms_forms_y = (<any>(null as any));
var _decl0_27:i16.DefaultValueAccessor = (<any>(null as any));
var _decl0_28:i16.NumberValueAccessor = (<any>(null as any));
var _decl0_29:i16.RangeValueAccessor = (<any>(null as any));
var _decl0_30:i16.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_31:i16.SelectControlValueAccessor = (<any>(null as any));
var _decl0_32:i16.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_33:i16.RadioControlValueAccessor = (<any>(null as any));
var _decl0_34:i16.NgControlStatus = (<any>(null as any));
var _decl0_35:i16.NgControlStatusGroup = (<any>(null as any));
var _decl0_36:i16.RequiredValidator = (<any>(null as any));
var _decl0_37:i16.MinLengthValidator = (<any>(null as any));
var _decl0_38:i16.MaxLengthValidator = (<any>(null as any));
var _decl0_39:i16.PatternValidator = (<any>(null as any));
var _decl0_40:i16.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_41:i16.EmailValidator = (<any>(null as any));
var _decl0_42:i16.NgModel = (<any>(null as any));
var _decl0_43:i16.NgModelGroup = (<any>(null as any));
var _decl0_44:i16.NgForm = (<any>(null as any));
var _decl0_45:i16.NgFormSelectorWarning = (<any>(null as any));
var _decl0_46:i17.RouterOutlet = (<any>(null as any));
var _decl0_47:i17.RouterLink = (<any>(null as any));
var _decl0_48:i17.RouterLinkWithHref = (<any>(null as any));
var _decl0_49:i17.RouterLinkActive = (<any>(null as any));
var _decl0_50:i17.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_51:i18.ElCardComponent = (<any>(null as any));
var _decl0_52:i18.ElCardBodyComponent = (<any>(null as any));
var _decl0_53:i18.ElCardFooterComponent = (<any>(null as any));
var _decl0_54:i18.ElCardHeaderComponent = (<any>(null as any));
var _decl0_55:i19.ElRevealCardComponent = (<any>(null as any));
var _decl0_56:i20.ElFlipCardComponent = (<any>(null as any));
var _decl0_57:i21.ElCardFrontComponent = (<any>(null as any));
var _decl0_58:i21.ElCardBackComponent = (<any>(null as any));
var _decl0_59:i22.ElBaseCalendarComponent<any,any> = (<any>(null as any));
var _decl0_60:i15.AsyncPipe = (<any>(null as any));
var _decl0_61:i15.UpperCasePipe = (<any>(null as any));
var _decl0_62:i15.LowerCasePipe = (<any>(null as any));
var _decl0_63:i15.JsonPipe = (<any>(null as any));
var _decl0_64:i15.SlicePipe = (<any>(null as any));
var _decl0_65:i15.DecimalPipe = (<any>(null as any));
var _decl0_66:i15.PercentPipe = (<any>(null as any));
var _decl0_67:i15.TitleCasePipe = (<any>(null as any));
var _decl0_68:i15.CurrencyPipe = (<any>(null as any));
var _decl0_69:i15.DatePipe = (<any>(null as any));
var _decl0_70:i15.I18nPluralPipe = (<any>(null as any));
var _decl0_71:i15.I18nSelectPipe = (<any>(null as any));
var _decl0_72:i15.KeyValuePipe = (<any>(null as any));
var _decl0_73:i23.ElCalendarKitModule = (<any>(null as any));
var _decl0_74:i24.ElSharedModule = (<any>(null as any));
var _decl0_75:i25.ElCardModule = (<any>(null as any));
var _decl0_76:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_77:i0.ElementRef<any> = (<any>(null as any));
function _View_ElBaseCalendarComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_59.showWeekNumber;
  currVal_0;
  const currVal_1:any = _decl0_59.medium;
  currVal_1;
  const currVal_2:any = _decl0_59.large;
  currVal_2;
}
function _View_ElBaseCalendarComponent_1_1():void {
  if (_decl0_59.showHeader) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_59.navigateToday()) !== false);
  }
}
function _View_ElBaseCalendarComponent_1_3():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_59.visibleDate;
  currVal_0;
  const pd_1:any = ((<any>_decl0_59.nextMonth()) !== false);
  const pd_2:any = ((<any>_decl0_59.prevMonth()) !== false);
  const pd_3:any = ((<any>_decl0_59.setViewMode(_decl0_59.ViewMode.YEAR)) !== false);
}
function _View_ElBaseCalendarComponent_1_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_59.ViewMode.DATE;
  currVal_0;
  const currVal_1:any = _decl0_59.visibleDate;
  currVal_1;
  const currVal_2:any = _decl0_59.boundingMonth;
  currVal_2;
  const currVal_3:any = _decl0_59.min;
  currVal_3;
  const currVal_4:any = _decl0_59.max;
  currVal_4;
  const currVal_5:any = _decl0_59.filter;
  currVal_5;
  const currVal_6:any = _decl0_59.dayCellComponent;
  currVal_6;
  const currVal_7:any = _decl0_59.size;
  currVal_7;
  const currVal_8:any = _decl0_59.date;
  currVal_8;
  const currVal_9:any = _decl0_59.showWeekNumber;
  currVal_9;
  const currVal_10:any = _decl0_59.weekNumberSymbol;
  currVal_10;
  const currVal_11:any = _decl0_6.medium;
  currVal_11;
  const currVal_12:any = _decl0_6.large;
  currVal_12;
  const pd_13:any = ((<any>_decl0_59.dateChange.emit(_any)) !== false);
}
function _View_ElBaseCalendarComponent_1_4():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_59.visibleDate;
  currVal_0;
  const currVal_1:any = _decl0_59.date;
  currVal_1;
  const currVal_2:any = _decl0_59.min;
  currVal_2;
  const currVal_3:any = _decl0_59.max;
  currVal_3;
  const currVal_4:any = _decl0_59.filter;
  currVal_4;
  const currVal_5:any = _decl0_59.yearCellComponent;
  currVal_5;
  const currVal_6:any = _decl0_59.size;
  currVal_6;
  const currVal_7:any = _decl0_59.visibleDate;
  currVal_7;
  const currVal_8:any = _decl0_4.medium;
  currVal_8;
  const currVal_9:any = _decl0_4.large;
  currVal_9;
  const pd_10:any = ((<any>_decl0_59.nextYears()) !== false);
  const pd_11:any = ((<any>_decl0_59.prevYears()) !== false);
  const pd_12:any = ((<any>_decl0_59.setViewMode(_decl0_59.ViewMode.DATE)) !== false);
  _decl0_59.setVisibleDate(_any);
  const pd_13:any = ((<any>_decl0_59.setViewMode(_decl0_59.ViewMode.MONTH)) !== false);
}
function _View_ElBaseCalendarComponent_1_5():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_59.visibleDate;
  currVal_0;
  const currVal_1:any = _decl0_59.min;
  currVal_1;
  const currVal_2:any = _decl0_59.max;
  currVal_2;
  const currVal_3:any = _decl0_59.filter;
  currVal_3;
  const currVal_4:any = _decl0_59.size;
  currVal_4;
  const currVal_5:any = _decl0_59.visibleDate;
  currVal_5;
  const currVal_6:any = _decl0_59.monthCellComponent;
  currVal_6;
  const currVal_7:any = _decl0_5.medium;
  currVal_7;
  const currVal_8:any = _decl0_5.large;
  currVal_8;
  const pd_9:any = ((<any>_decl0_59.setViewMode(_decl0_59.ViewMode.DATE)) !== false);
  _decl0_59.setVisibleDate(_any);
  const pd_10:any = ((<any>_decl0_59.setViewMode(_decl0_59.ViewMode.DATE)) !== false);
}
function _View_ElBaseCalendarComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_51.tiny;
  currVal_0;
  const currVal_1:any = _decl0_51.small;
  currVal_1;
  const currVal_2:any = _decl0_51.medium;
  currVal_2;
  const currVal_3:any = _decl0_51.large;
  currVal_3;
  const currVal_4:any = _decl0_51.giant;
  currVal_4;
  const currVal_5:any = _decl0_51.primary;
  currVal_5;
  const currVal_6:any = _decl0_51.info;
  currVal_6;
  const currVal_7:any = _decl0_51.success;
  currVal_7;
  const currVal_8:any = _decl0_51.warning;
  currVal_8;
  const currVal_9:any = _decl0_51.danger;
  currVal_9;
  const currVal_10:any = _decl0_51.hasAccent;
  currVal_10;
  const currVal_11:any = _decl0_51.primaryAccent;
  currVal_11;
  const currVal_12:any = _decl0_51.infoAccent;
  currVal_12;
  const currVal_13:any = _decl0_51.successAccent;
  currVal_13;
  const currVal_14:any = _decl0_51.warningAccent;
  currVal_14;
  const currVal_15:any = _decl0_51.dangerAccent;
  currVal_15;
  const currVal_16:any = _decl0_59.showHeader;
  currVal_16;
  const currVal_17:any = _decl0_59.activeViewMode;
  currVal_17;
  const currVal_18:any = _decl0_59.ViewMode.DATE;
  currVal_18;
  const currVal_19:any = _decl0_59.ViewMode.YEAR;
  currVal_19;
  const currVal_20:any = _decl0_59.ViewMode.MONTH;
  currVal_20;
}
